import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ entityId, routes }) => {
  return await dponetAPI.get(`${routes}/${entityId}/logs`)
}

export default get
